import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    pastaMae: DocumentoPasta | null;
    onConfirm: () => void;
}

const documentoPastaService = new DocumentoPastaService();
export default function ModalDocumentoPastaCriar(props: Props) {
    const [pasta, setPasta] = useState<DocumentoPasta>(new DocumentoPasta(0, '', props.pastaMae));
    const [pastas, setPastas] = useState<DocumentoPasta[]>([]);

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();

    function handleConfirm() {
        if(!pasta.nome || pasta.nome.trim() === '') {
            msgAlerta("Erro", "O nome da pasta não pode ser vazio.");
            return;
        }

        startLoading();
        let pastaLocal = { ...pasta };
        if (pastaLocal.pastaMae && pastaLocal.pastaMae.id === 0) {
            pastaLocal.pastaMae = null; // Se a pasta mãe for a raiz, não atribui
        }
        documentoPastaService.criar(pastaLocal).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao criar", error?.data?.message || "Erro ao criar pasta");
            console.error("Erro ao criar pasta:", error);
        });

    }

    useEffect(() => {
        console.log(props.pastaMae)
        documentoPastaService.buscarTodas().then((json) => {
            json.unshift(new DocumentoPasta(0, '(Raiz)', null))
            setPastas(json);
        }).catch((error) => {
            console.error("Erro ao buscar pastas:", error);
        });
    }, [])

    return (
        <Dialog
            header="Criar Pasta"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Criar" icon="pi pi-check" onClick={handleConfirm} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Label>Nome</Label>
                <InputText
                    value={pasta.nome}
                    onChange={(e) => setPasta({ ...pasta, nome: e.target.value })}
                />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Label>Pasta mãe</Label>
                <Dropdown
                    value={pasta.pastaMae}
                    onChange={(e) => setPasta({ ...pasta, pastaMae: e.value })}
                    options={pastas}
                    optionLabel="nome"
                    dataKey="id"
                />
            </div>

        </Dialog>
    );
}